<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5816 13.9849H14.2212H18.5146H19.1542C19.5981 13.9849 19.9609 14.3601 19.9609 14.8192V19.5831C19.9609 20.0422 19.5981 20.4175 19.1542 20.4175H13.5816C13.1377 20.4175 12.7749 20.0422 12.7749 19.5831V14.8192C12.7749 14.3601 13.1377 13.9849 13.5816 13.9849ZM17.7299 17.2012C17.7299 17.9796 17.1202 18.6102 16.3676 18.6102C15.6156 18.6102 15.0052 17.9796 15.0052 17.2012C15.0052 16.4235 15.6156 15.7921 16.3676 15.7921C17.1202 15.7921 17.7299 16.4235 17.7299 17.2012Z"
      fill="currentColor"
    />
    <path
      d="M16.3672 11.1772C17.7846 11.1772 18.9336 12.3263 18.9336 13.7437H17.9336C17.9336 12.8785 17.2323 12.1772 16.3672 12.1772C15.5021 12.1773 14.8008 12.8786 14.8008 13.7437H13.8008C13.8008 12.3263 14.9498 11.1773 16.3672 11.1772Z"
      fill="currentColor"
    />
    <path
      d="M8.73535 0.0238752C8.83103 -0.00794583 8.93461 -0.00797098 9.03027 0.0238752L17.4385 2.6352C17.6378 2.69918 17.7656 2.86656 17.7656 3.05805V9.61079C17.5687 9.59123 17.369 9.58151 17.167 9.58149C17.0518 9.58149 16.9369 9.58484 16.8232 9.59126V3.37739L8.88672 0.910594L0.942383 3.37739V10.1323C0.942384 10.9786 1.3335 15.3939 8.88672 20.0249C9.74004 19.5017 10.4991 18.9778 11.1787 18.4643V19.5883C10.5403 20.0429 9.85994 20.4915 9.13379 20.9272C9.06198 20.975 8.97444 20.9995 8.88672 20.9995C8.7989 20.9995 8.7107 20.9751 8.63086 20.9272C5.24569 18.8913 2.79477 16.6476 1.34961 14.2524C0.135969 12.2323 5.95545e-07 10.6992 0 10.1323V3.05805C0 2.86653 0.135682 2.69916 0.327148 2.6352L8.73535 0.0238752Z"
      fill="currentColor"
    />
    <path
      d="M8.62728 8.66049C7.3409 8.66049 6.29395 7.61361 6.29395 6.32715C6.29395 5.04069 7.3409 3.99219 8.62728 3.99219C9.91537 3.99219 10.9639 5.04069 10.9639 6.32715C10.9639 7.61361 9.91537 8.66049 8.62728 8.66049Z"
      fill="currentColor"
    />
    <path
      d="M10.2563 12.802C9.17336 12.802 8.09071 12.7883 7.00765 12.802C7.00765 12.802 5.9131 12.7846 5.50701 12.6592C4.91536 12.4753 4.79004 12.0867 4.79004 11.7963C4.79004 10.6781 5.83066 8.90625 8.62718 8.90625C11.4793 8.90625 12.5135 10.6336 12.5135 11.7963C12.5135 12.802 11.1541 12.802 10.2563 12.802Z"
      fill="currentColor"
    />
  </svg>
</template>
